import { render } from "./AllRiskView.vue?vue&type=template&id=9a6cdf2a&scoped=true"
import script from "./AllRiskView.vue?vue&type=script&lang=js"
export * from "./AllRiskView.vue?vue&type=script&lang=js"

import "./AllRiskView.vue?vue&type=style&index=0&id=9a6cdf2a&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a6cdf2a"]])

export default __exports__